
import { toast } from "@/components/ui/use-toast";
import { AxiosError } from "axios";

interface ApiError {
  code: string;
  message: string;
  details?: string[];
}

export const handleApiError = (error: AxiosError<ApiError>, title: string) => {
  const errorMessage = error.response?.data?.message || "An unexpected error occurred";
  
  toast({
    variant: "destructive",
    title: title,
    description: errorMessage,
  });

  // Log error for debugging
  console.error(`${title}:`, {
    status: error.response?.status,
    message: errorMessage,
    details: error.response?.data?.details,
  });

  throw error;
};

